var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30432 14.652C1.6716 14.652 0.347656 13.3282 0.347656 11.696L0.347656 8.44601C0.347656 6.8132 1.67151 5.48934 3.30432 5.48934H3.92632C4.20247 5.48934 4.42632 5.7132 4.42632 5.98934C4.42632 6.26548 4.20247 6.48934 3.92632 6.48934H3.30432C2.2238 6.48934 1.34766 7.36548 1.34766 8.44601L1.34766 11.696C1.34766 12.7758 2.22371 13.652 3.30432 13.652H10.7243C11.8049 13.652 12.681 12.7758 12.681 11.696V8.43934C12.681 7.36264 11.808 6.48934 10.7317 6.48934H10.103C9.82685 6.48934 9.60299 6.26548 9.60299 5.98934C9.60299 5.7132 9.82685 5.48934 10.103 5.48934H10.7317C12.3606 5.48934 13.681 6.81071 13.681 8.43934V11.696C13.681 13.3282 12.357 14.652 10.7243 14.652H3.30432Z",
    fill: "#1976d2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01416 9.98767C6.73802 9.98767 6.51416 9.76381 6.51416 9.48767L6.51416 1.46034C6.51416 1.1842 6.73802 0.960338 7.01416 0.960338C7.2903 0.960338 7.51416 1.1842 7.51416 1.46034L7.51416 9.48767C7.51416 9.76381 7.2903 9.98767 7.01416 9.98767Z",
    fill: "#1976d2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71803 3.76688C4.52234 3.57205 4.52163 3.25547 4.71646 3.05977L6.65979 1.10777C6.75362 1.01353 6.88111 0.960548 7.01409 0.960537C7.14707 0.960525 7.27458 1.01349 7.36841 1.10771L9.31241 3.05971C9.50727 3.25537 9.50662 3.57195 9.31096 3.76682C9.1153 3.96168 8.79872 3.96103 8.60386 3.76536L7.01419 2.16916L5.42514 3.7653C5.23031 3.961 4.91373 3.9617 4.71803 3.76688Z",
    fill: "#1976d2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.c101db558f862820217ec1d3839d2516.svg";
export { ForwardRef as ReactComponent };